import React, { ComponentProps } from 'react';
import WarningAttentionBox from './WarningAttentionBox';

type ErrorAttentionBoxProps = Omit<
  ComponentProps<typeof WarningAttentionBox>,
  'colorScheme'
>;

/** The alert box in the error scheme, for failures the operator has to act on. */
const ErrorAttentionBox = (props: ErrorAttentionBoxProps) => (
  <WarningAttentionBox {...props} colorScheme="error" />
);

export default ErrorAttentionBox;
